<script>
import PriceListItemIcon from "@js/components/Sections/PriceList/Components/PriceListItemIcon.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";

export default {
    name: "PriceListItem",
    components: {OnlyMobile, OnlyDesktop, PriceListItemIcon},
    data() {
        return {
            is_hovered: false,
        };
    },
};
</script>

<template>
    <OnlyDesktop>
        <div
            @mouseenter="is_hovered=true"
            @mouseleave="is_hovered=false"
            class="min-h-[110px] max-w-md w-full flex overflow-hidden rounded-2xl shadow-md relative cursor-pointer intro-x z-1">
            <div
                class="bg-[url('@img/example.webp')] h-full w-24 flex-none bg-cover bg-center rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden">
            </div>
            <div
                class="p-5 flex flex-col justify-between leading-normal">
                <div>
                    <div class="text-black font-bold text-sm mb-2">
                        Плиты укреплений
                    </div>
                </div>
                <div class="flex gap-10">
                    <div>
                        <p class="text-xs text-gray-600 font-normal">
                            Безнал.
                        </p>
                        <p class="flex items-center font-medium text-md">
                        <span class="me-1">
                            430 ₽/кг.
                        </span>
                            <PriceListItemIcon/>
                        </p>
                    </div>
                    <div>
                        <p class="text-xs text-gray-600 font-normal">
                            Наличные
                        </p>
                        <p class="flex items-center font-medium text-md">
                        <span class="me-1">
                            430 ₽/кг.
                        </span>
                            <PriceListItemIcon :isRising="false"/>
                        </p>
                    </div>
                </div>
            </div>
            <div class="absolute bottom-0 right-0">
                <div
                    :class="{
                    'bg-indigo-600 text-white': is_hovered,
                    'text-indigo-600 bg-transparent': !is_hovered,
                }"
                    class="w-[65px] h-[65px] text-xs flex items-center justify-center rounded-tl-full pt-4 ps-4 font-bold transition-all duration-500"
                >
                    Ещё
                </div>
            </div>
        </div>
    </OnlyDesktop>
    <OnlyMobile>
        <div
            class="min-h-[110px] max-w-md w-full  rounded-2xl shadow-md relative border border-gray-200 mt-5 intro-x z-1">
            <div class="w-full flex justify-center">
                <div
                    class="bg-[url('@img/example.webp')] h-24 w-24 flex-none bg-cover bg-center rounded-full text-center overflow-hidden -mt-5">
                </div>
            </div>
            <div
                class="p-3 flex flex-col justify-between leading-normal">
                <div>
                    <div class="text-black font-bold text-sm mb-2 text-center">
                        Плиты укреплений
                    </div>
                </div>
                <div>
                    <div class="flex items-center justify-between mt-2">
                        <div class="text-xs text-gray-600 font-normal">
                            Безнал.
                        </div>
                        <div class="flex items-center font-medium text-xs">
                        <span class="me-1">
                            430 ₽/кг.
                        </span>
                            <PriceListItemIcon/>
                        </div>
                    </div>
                    <div class="flex items-center justify-between mt-2">
                        <div class="text-xs text-gray-600 font-normal">
                            Наличные
                        </div>
                        <div class="flex items-center font-medium text-xs">
                        <span class="me-1">
                            430 ₽/кг.
                        </span>
                            <PriceListItemIcon/>
                        </div>
                    </div>
                </div>
                <div class="text-xs flex items-center justify-end pt-4 font-bold text-indigo-600">
                    Ещё
                </div>
            </div>
        </div>
    </OnlyMobile>
</template>

<style scoped lang="scss">
.z-1 {
    z-index: 1 !important;
}
</style>
